<div class="logs-container">
  <div class="header-section">
    <div class="page-header">
      <div class="header-left">
        <h3 class="title text-dark">Logs</h3>
        <p class="subtitle">
          Manage and analyze system errors and application logs.
        </p>
      </div>
    </div>
  </div>

  <div class="filters-section">
    <div class="d-flex gap-2">
      <app-search-box (search)="onSearch($event)"></app-search-box>
      @if (showDeleteBtn()) {
        <button type="button" class="btn btn-outline" (click)="deleteLogs()">
          <i class="pi pi-trash"></i>
        </button>
      }
    </div>
    <div class="filters-container">
      <p-select
        [options]="logLevels"
        [(ngModel)]="selectedLogLevel"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        class="log-level-dropdown"
        placeholder="Select Log Level"
        (onChange)="loadData()">
      </p-select>

      <div class="date-filter">
        <p-datepicker
          [(ngModel)]="rangeDates"
          selectionMode="range"
          dateFormat="dd-mm-yy"
          [showClear]="true"
          (onSelect)="onDateFilter()"
          (onClear)="loadData()"
          placeholder="Select date range">
        </p-datepicker>
      </div>
      <button
        class="btn btn-outline select-all-btn"
        (click)="toggleSelectAll()">
        Select All
      </button>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="logger-table">
      <thead>
        <tr>
          <th class="checkbox-col">
            <input
              type="checkbox"
              [checked]="allSelected"
              (change)="toggleSelectAll()" />
          </th>
          <th class="sortable" (click)="onSort('LevelName')">Type <span class="sort-indicator">{{ getSortIcon('LevelName') }}</span></th>
          <th class="sortable" (click)="onSort('Timestamp')">Timestamp <span class="sort-indicator">{{ getSortIcon('Timestamp') }}</span></th>
          <th>Message</th>
          <th class="sortable" (click)="onSort('Application')">Application <span class="sort-indicator">{{ getSortIcon('Application') }}</span></th>
          <th>Method</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @if (loader()) {
          <tr>
            <td colspan="100%">
              <app-spinner-loader [width]="35" />
            </td>
          </tr>
        } @else if (logs().length === 0) {
          <tr>
            <td colspan="100%" class="no-data-cell">No log found</td>
          </tr>
        } @else {
          <ng-container *ngFor="let log of logs(); let i = index">
            <tr [class.selected]="log.selected">
              <td class="checkbox-col">
                <input
                  type="checkbox"
                  [(ngModel)]="log.selected"
                  (change)="updateSelectAllState()" />
              </td>
              <td class="log-type">
                <div [class]="'type-chip ' + log.level.toLowerCase()">
                  {{ log.level }}
                </div>
              </td>
              <td class="log-timestamp">
                {{ log.timestamp | date: "yyyy-MM-dd HH:mm" }}
              </td>
              <td class="log-message">
                <span
                  class="message-txt"
                  [title]="log.message"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top">
                  {{ log.message }}
                </span>
              </td>
              <td class="log-application">{{ log.application }}</td>
              <td class="log-method">{{ log.metadata?.methodType }}</td>
              <td class="actions">
                <button class="btn btn-view" (click)="viewDetails(log)">
                  View
                </button>
              </td>
            </tr>
          </ng-container>
        }
      </tbody>
    </table>

    <div class="pagination-section">
      <div class="pagination-info">
        <span>
          Showing {{ startIndex }} to {{ endIndex }} of
          {{ totalEntries() }} Entries
        </span>
      </div>
      <div class="pagination-controls">
        @if (logs().length !== 0) {
          <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
          <select
            id="pageSizeSelect"
            [(ngModel)]="itemsPerPage"
            (ngModelChange)="onPageSizeChange($event)"
            class="form-select">
            <option *ngFor="let size of pageSizes" [value]="size">
              {{ size }}
            </option>
          </select>
        }
        <button
          class="btn btn-outline pagination-btn"
          [disabled]="currentPage === 1 || logs().length === 0"
          (click)="previousPage()">
          &lt; Prev
        </button>
        <button
          class="btn btn-outline pagination-btn"
          [disabled]="currentPage === totalPages || logs().length === 0"
          (click)="nextPage()">
          Next &gt;
        </button>
      </div>
    </div>
  </div>
</div>

@if (isView() && selectedLog()) {
  <app-log-details-modal
    [visible]="isView()"
    [log]="selectedLog()!"
    (onClose)="closeViewDetails()"></app-log-details-modal>
}
